import { Rect } from "./overlaySelectionIndicator";

/** Keep editing controls reachable, including for rotated/off-canvas overlays. */
export function getOverlayToolbarPosition(
  bounds: Rect,
  canvasWidth: number,
  canvasHeight: number,
  toolbarHeight: number,
) {
  const margin = 4;
  const gap = 8;
  const toolbarWidth = 34;
  const right = bounds.left + bounds.width;
  const preferredLeft =
    right + gap + toolbarWidth <= canvasWidth - margin
      ? right + gap
      : right - toolbarWidth - gap;
  return {
    left: Math.max(
      margin,
      Math.min(preferredLeft, canvasWidth - toolbarWidth - margin),
    ),
    top: Math.max(
      margin,
      Math.min(bounds.top, canvasHeight - toolbarHeight - margin),
    ),
  };
}
